import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../../../shared/services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(private loaderService: LoaderService) {}

intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  const skipLoader = req.headers.has('X-Skip-Loader');

  if (!skipLoader) {
    // this.loaderService.show();
  }

  return next.handle(req).pipe(
    finalize(() => {
      if (!skipLoader) {
        // this.loaderService.hide();
      }
    })
  );
}

}